export enum PreInvoicingStateEnums{
    error = 1,
    alerta = 2,
    ok = 3
  }